var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{ref:"datetime",attrs:{"type":"datetimerange","value-format":"yyyy-MM-dd HH:mm:ss","size":_vm.size,"picker-options":_vm.pickerOptions,"placeholder":"选择时间范围","range-separator":" ~ ","align":"right"},on:{"change":_vm.updateValue},model:{value:(_vm.bindValue),callback:function ($$v) {_vm.bindValue=$$v},expression:"bindValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }